/// <reference path="../../../../wwwroot/Scripts/kendo/kendo.all.d.ts" />

namespace PaperTrail.NewsletterControl {
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class SubscriptionListViewDialog extends Serenity.TemplatedDialog<any> {

        public userId: any;

        protected onDialogOpen() {
            super.onDialogOpen();

            Q.Router.replace("Stories");

            let self = this;

            $(document).ready(function () {
                // Spin all loading indicators on the page
                kendo.ui.progress($(".listview-loading"), true);
               
            });

            $(function () {


                var listViewDataSource = new kendo.data.DataSource({
                    type: "json",
                    transport: {
                        read: {
                            url: Q.resolveUrl("~/Services/" + SubscriptionService.Methods.ListByUser),
                            type: "POST",
                            data: {}
                        },
                        parameterMap: function (data, type) {
                            if (type == "read") {
                                return kendo.stringify(data);
                            }
                        }
                    },
                    schema: {
                        data: "Entities"
                    }
                });

                var listView = $("#listView").kendoListView({
                    dataSource: listViewDataSource,
                    template: kendo.template($("#template").html()), 
                    dataBound: function (e) { 
                        //console.log(e);
                        var newsletterExpansionPanels = [];
                        $(".cards").each(function (i, el) {
                            var thisdiv = this as HTMLDivElement;
                            var expanded = false;
                            if (i == 0) {
                                expanded = true;
                            }
                            var titleAndSubtitle = thisdiv.title.split("stardsepstar")
                            var title = titleAndSubtitle[0];
                            //var ic = '<button id="inviteContributor" name="inviteContributor" class="k-button" onclick="inviteContributor(' + titleAndSubtitle[2] + ')">Invite</button>';
                            //title += escape(ic);
                            var subTitle = titleAndSubtitle[1];
                            //console.log(titleAndSubtitle);
                            //console.log(title);
                            //console.log(subTitle);
                            var ep = $(this).kendoExpansionPanel({
                                title: title,
                                subTitle: subTitle,
                                expanded: expanded
                            }).data("kendoExpansionPanel");
                            newsletterExpansionPanels.push(ep);

                            // Clear up the loading indicator for this chart
                            var loading = $(".listview-loading", e.sender.element.parent());
                            kendo.ui.progress(loading, false);

                            //var button = document.createElement("button");

                            //button.id = "myButton";
                            //button.textContent = "Click me";
                            //button.addEventListener("click", doSomething, false);
                            //$('<button id="inviteContributor" name="inviteContributor" class="k-button" onclick="inviteContributor(' + titleAndSubtitle[2] + ')">Invite</button>').insertBefore(".k-expander-spacer");
                            ////button.insertBefore(".k-expander-spacer");
                        });

                        //$.each(newsletterExpansionPanels, function () {
                        //    console.log($(this));
                        //});

                        //var subscriptionExpansionPanels = [];
                        //$(".subscriptions").each(function (i, el) {
                        //    //console.log(el);
                        //    var thisdiv = this as HTMLDivElement;
                        //    var expanded = false;
                        //    if (i == 0) {
                        //        expanded = true;
                        //    }
                        //    var ep = $(this).kendoExpansionPanel({
                        //        title: thisdiv.title,
                        //        expanded: expanded
                        //    }).data("kendoExpansionPanel");
                        //    subscriptionExpansionPanels.push(ep);
                        //});
                    }
                }).data("kendoListView");

                $(document).on("actionDone", function (event) { 
                    listView.dataSource.read();
                    listView.refresh();
                    Q.success("With a little magic we can publish Newsletters but we still need your stories.  Don't forget to come back with the latest news you have to share.", null, { title:  "Story Submitted"});
                });

            });

            function doSomething() {
                alert("hi");
            }
        }
         
        protected close() {
            let self = this;
            self.dialogClose();
        }

        protected onDialogClose() {
            super.onDialogClose();
        }

        protected getDialogOptions() {
            var opt = super.getDialogOptions();

            return opt;
        }
    }
}